<div class="w-full">
	<div class="card">
		<div class="font-semibold text-xl mb-4">
			{{translateServ.dictionary["ITEM_INDEX_HIST"]}}
		</div>

		<p-table [style]="{'width': '100%'}" [value]="indexHistory" dataKey="id" [expandedRowKeys]="expandedRows"
			[responsiveLayout]="'scroll'">

			<!-- ================= HEADER ================= -->
			<ng-template pTemplate="header">
				<tr>
					<th style="width: 3rem;"></th>
					<th>{{translateServ.dictionary["JMT_COL_ID"]}}</th>
					<th>{{translateServ.dictionary["USER_NAME"]}}</th>
					<th>{{translateServ.dictionary["INXD_HIS_IMP_ID"]}}</th>
					<th>{{translateServ.dictionary["PARENT_IMPORT_ID"] || 'Parent Import ID'}}</th>
					<th>{{translateServ.dictionary["NOTIFICATION_DATE"]}}</th>
					<th>{{translateServ.dictionary["MAINT_IN_TIT_STAT"]}}</th>
					<th>{{translateServ.dictionary["MAINT_IN_TIT_DESC"]}}</th>
					<th>{{translateServ.dictionary["STEP_TAB_TIT_ACT"]}}</th>
				</tr>
			</ng-template>

			<!-- ================= BODY ================= -->
			<ng-template pTemplate="body" let-row>
				<tr>
					<td>
						<button type="button" class="p-button p-button-text p-button-sm p-button-rounded"
							(click)="toggleRow(row)">
							<i class="pi" [ngClass]="expandedRows[row.id] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
						</button>
					</td>
					<td>
						{{ row.id }}
						<ng-container *ngIf="row.code == 100">
							<i class="pi pi-exclamation-circle text-yellow-500 ml-2"
								pTooltip="{{translateServ.dictionary['NEED_TO_COMPLETE'] || 'Needs completion'}}"></i>
						</ng-container>
					</td>
					<td>{{ row.userName }}</td>
					<td>{{ row.importId }}</td>
					<td>{{ row.Parent_Import_ID || '-' }}</td>
					<td>{{ row.date }}</td>
					<td>
						<div class="text-xs mt-1"
							[ngClass]="row.code == 100 ? 'text-yellow-500 font-semibold' : 'text-green-500'">
							{{ row.stage }}
						</div>
					</td>
					<td>{{ row.details }}</td>
					<td>
						<button pButton icon="pi pi-download" class="p-button-text p-button-sm" (click)="getNoteFile(row.importId)" pTooltip="{{ translateServ.dictionary['DOWNLOAD_FILE'] }}"></button>
						<button
							pButton
							[icon]="reloadLoading[row.id] ? 'pi pi-spin pi-spinner' : 'pi pi-replay'"
							class="p-button-text p-button-sm"
							[disabled]="reloadLoading[row.id]"
							(click)="reloadIndex(row)"
							pTooltip="{{ translateServ.dictionary['RELOAD_INDEX'] || 'Reload index' }}"
						></button>
					</td>
				</tr>
				<!-- Expanded details table -->
				<tr *ngIf="expandedRows[row.id]">
					<td colspan="9" class="expanded-row-background p-3">
						<div *ngIf="expansionLoading[row.id]" class="flex items-center justify-center py-4">
							<i class="pi pi-spin pi-spinner text-primary-500 text-2xl mr-2"></i>
							<span>{{translateServ.dictionary["LOADING"]}}</span>
						</div>
						<ng-container *ngIf="!expansionLoading[row.id] && expansionDetails[row.id]">
							<!-- Tabs -->
							<div class="mb-4 flex border-b border-gray-200">
								<button type="button" class="px-4 py-2 focus:outline-none" [ngClass]="{'font-bold border-b-2 border-primary-500': activeExpansionTab[row.id] !== 'assignment'}" (click)="activeExpansionTab[row.id] = 'source'">
									{{ translateServ.dictionary['INDEX_HIS_SOURCE_FILES']}}
								</button>
								<button type="button" class="px-4 py-2 focus:outline-none" [ngClass]="{'font-bold border-b-2 border-primary-500': activeExpansionTab[row.id] === 'assignment'}" (click)="activeExpansionTab[row.id] = 'assignment'; getAssignmentHistory(row.importId, row.id)">
									{{ translateServ.dictionary['INDEX_HIS_ASSIGNED_SEC']}}
								</button>
							</div>
							<!-- Source Files Tab -->
							<div *ngIf="!activeExpansionTab[row.id] || activeExpansionTab[row.id] === 'source'">
								<p-table [value]="expansionDetails[row.id]" [style]="{'width':'100%'}" *ngIf="expansionDetails[row.id]">
									<ng-template pTemplate="header">
										<tr>
											<th class="px-2 py-1 text-left">{{translateServ.dictionary["FILE_NAME"]}}</th>
											<th class="px-2 py-1 text-left">{{translateServ.dictionary["INDEXES"]}}</th>
											<th class="px-2 py-1 text-left">{{translateServ.dictionary["FILE_STATUS"]}}</th>
											<th class="px-2 py-1 text-left">{{translateServ.dictionary["MAINT_IN_TIT_DESC"]}}</th>
											<th class="px-2 py-1 text-left">{{translateServ.dictionary["DOWNLOAD_FILE"]}}</th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-detail>
										<tr>
											<td class="px-2 py-1">{{ detail.fileName }}</td>
											<td class="px-2 py-1">
												<ng-container *ngFor="let indexName of getIndexTypeTags(detail.indexTypeName)">
													<p-tag [value]="getTranslatedIndexType(indexName)" [severity]="getIndexTagSeverity(indexName)" class="mr-1"></p-tag>
												</ng-container>
											</td>
											<td class="px-2 py-1">
												<span [ngClass]="detail.status == '1' ? 'text-green-600' : 'text-red-600'">{{ detail.status == '1' ? translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_ACT'] : translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_INACT'] }}</span>
											</td>
											<td class="px-2 py-1">{{ detail.details }}</td>
											<td class="px-2 py-1">
												<button pButton icon="pi pi-download" class="p-button-text p-button-sm" (click)="downloadFile(detail)" [disabled]!="detail.url" pTooltip="Download"></button>
											</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="5" class="text-center text-red-500 py-4">
												{{translateServ.dictionary["LOADING_DATA_ERR_MSG"]}}
											</td>
										</tr>
									</ng-template>
								</p-table>
								<!-- Finish Upload Button for code 100 -->
								<div *ngIf="row.code == 100 && expansionDetails[row.id]?.length === 3" class="flex justify-end mt-4">
									<button pButton type="button" label="{{ translateServ.dictionary['FIN_UPL'] }}" class="p-button-success" (click)="openFinishUploadDialog(row, expansionDetails[row.id])"></button>
								</div>
							</div>
							<!-- Assignment History Tab -->
							<div *ngIf="activeExpansionTab[row.id] === 'assignment'">
								<div *ngIf="assignmentLoading[row.id]" class="flex items-center justify-center py-4">
									<i class="pi pi-spin pi-spinner text-primary-500 text-2xl mr-2"></i>
									<span>{{translateServ.dictionary['LOADING']}}</span>
								</div>
								<p-table *ngIf="!assignmentLoading[row.id] && assignmentHistory[row.id]" [value]="assignmentHistory[row.id]" [style]="{'width':'100%'}">
									<ng-template pTemplate="header">
										<tr>
											<th class="px-2 py-1 text-left">{{ translateServ.dictionary['INDEX_TABL_SEC_CODE']}}</th>
											<th class="px-2 py-1 text-left">{{ translateServ.dictionary['INDEX_TABL_SEC_NAME']}}</th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-assignment>
										<tr>
											<td class="px-2 py-1">{{ assignment.SectionNumber }}</td>
											<td class="px-2 py-1">{{ assignment.SectionName }}</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="2" class="text-center text-red-500 py-4">{{ translateServ.dictionary['LOADING_DATA_ERR_MSG'] }}</td>
										</tr>
									</ng-template>
								</p-table>
							</div>
						</ng-container>
						<p-toast></p-toast>
					</td>
				</tr>
		</ng-template>

		<!-- ================= EMPTY ================= -->
		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="9" class="text-center p-4">
					<i class="pi pi-history text-400 text-2xl"></i>
					<p class="text-500 mt-2">
						{{ translateServ.dictionary['INDX_UPL_NOT_FOUND'] }}
					</p>
				</td>
			</tr>
		</ng-template>

		</p-table>


		<p-toast></p-toast>

	</div>
</div>